import { Box, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import Link from '@/components/Link';
import { Testimonial, TestimonialTextKey } from '@/config/testimonials.config';

import styles from './TestimonialCard.module.scss';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  const { quote, author, role, avatar, link } = testimonial;
  const t = useTranslations('common');

  return (
    <Box className={styles.container}>
      <Typography
        variant="subtitle1"
        component="p"
        textAlign="center"
        className={styles.quote}
        sx={{
          typography: { xs: 'subtitle2', md: 'subtitle1' },
        }}
      >
        {t(quote as TestimonialTextKey)}
      </Typography>
      <Stack alignItems="center" spacing={3} className={styles.author}>
        <Stack direction="row" alignItems="center" gap={1} className={styles.authorContent}>
          {avatar && <Image src={avatar.src} alt={avatar.alt} width={48} height={48} />}
          <Stack gap={0.5} alignItems="flex-start">
            <Typography textAlign="left" variant="subtitle2" component="p">
              {author}
            </Typography>
            <Typography variant="body2" textAlign="left" className={styles.role}>
              {role}
            </Typography>
          </Stack>
        </Stack>
        <Link href={link.href} target={link.target} text={t(link.text as TestimonialTextKey)} />
      </Stack>
    </Box>
  );
};

export default TestimonialCard;
